<template>
  <div>
    <div class="common-box border-t0">
      <el-row class="row-one">
        <span class="row-one-title">基金卖出</span>
        <span class="row-one-subTitle">{{fundMessage.fundcodename}}</span>
        <Reback class="row-one-fr" @click.native="reback"></Reback>
      </el-row>
      <div v-show="stepDisplay == '1'" class="margin-t30">
        <el-form :model="sellForm" :rules="sellFormRules" ref="sellFormRef" label-width="100px" label-position="right" class="form-single">
          <el-form-item label="卖出份额：" prop="money">
            <el-input v-model="sellForm.money" :placeholder="'可用份额'+fundMessage.availbal+'份'" @blur="moneyBlur">
              <span slot="suffix" class="form-single-suf">份</span>
            </el-input>
            <span class="form-single-all" @click="CashAll">全部</span>
            <div v-show="scopeShow" class="el-form-item__error" style="width:500px;">{{sellRange}}</div>
          </el-form-item>
          <el-form-item label="收款方式：">
            <el-radio-group v-model="sellForm.pay">
              <el-radio :label="0">恒宝宝</el-radio>
              <el-radio :label="1">银行卡</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item class="margin-t-15">
            <p v-show="sellForm.pay==0" class="form-single-tips margin-t10">基金赎回到恒宝宝，通常情况下恒宝宝T+2日份额确认后可用，比选择回银行卡再购买基金至少快2天，具体时间以实际到账时间为准。</p>
            <!-- <BankCardList v-show="sellForm.pay==1" v-model="sellForm.card" @slected="getslectedValue" @func="slectedValue"></BankCardList> -->
          </el-form-item>
          <el-form-item label="银行卡：">
            <span style="color:#666;">{{sellForm.card+'，同卡进出，资金更安全'}}</span>
          </el-form-item>
          <el-form-item label="密码：" prop="pass" :error="errorMsg">
            <el-input class="inputThree" type="password" v-model="sellForm.pass" autoComplete="new-password" show-password></el-input>
            <el-input style="position:fixed;bottom:-9999px;"></el-input>
          </el-form-item>
          <el-form-item>
            <div class="margin-t20">
              <el-button type="normal" @click="sellClick">{{sellText}}</el-button>
              <el-button type="cancel" class="fr" @click="reback">返回</el-button>
            </div>
          </el-form-item>
        </el-form>
        <!-- 说明 -->
        <div class="instruction-li">
          <p class="instruction-li-title  margin-t70">交易说明</p>
          <p class="instruction-li-stress">
            <span class="aColor">T日15:00前</span>（卖出基金申请受理） —— <span class="aColor">T+1日</span>（查看卖出确认情况，结束收益）——确认后<span class="aColor">1~13</span>个工作日内卖出资金到账
          </p>
          <p class="instruction-li-con">
            1. T日为工作日，当个工作日15:00后的交易将视作下一个工作日的交易发起，相应的确认时间也顺眼。<br>
            2. 基金交易确认日通常作为T+1日（QDII等特殊基金确认日为T+2日），您可在确认日20:00后查看确认信息。<br>
            3. 不同类型的基金赎回到账时间不同：一般货币基金T+1~2个工作日；债券基金T+2~4个工作日；混合、股票基金T+3~4个工作日；QDII基金T+4~13个工作日。资金到账时间一般为<br>
            <span class="instruction-li-m1"></span>到账工作日17:00前。个别银行可能存在到账时间延迟，具体到账时间以银行实际到账为准。<br>
            4. 如果您超过正常时间还未收到赎回款项，可拨打400-888-6661咨询。<br>
            5. 基金的赎回遵循“未知价”交易原则，即您赎回基金时都按提交业务申请当天的净值计算，而每天的净值是在交易结束后计算出来的，也就是说您在提交交易申请时不知道交易的价格。<br>
            <span class="instruction-li-m1"></span>因此您所看到的基金净值，为该基金上一交易日的基金净值，而非基金赎回成交时的基金净值。
          </p>
        </div>
      </div>
      <!-- 成功 -->
      <section class="xDetail" v-show="stepDisplay == '2'">
        <div class="xDetail-title">
          <img src="../../../assets/images/20210316_bigdg.png" alt="">
        </div>
        <p class="xDetail-title margin-t20">申请已受理</p>
        <ul class="xDetail-stepsone">
          <li class="xDetail-stepsone-li1">
            <div class="xDetail-stepsone-li1-head">
              <img src="../../../assets/images/time.png" alt="" width="20">
            </div>
            <div class="xDetail-stepsone-li1-main">{{'预计'+confirmTime.expectcfmdate+confirmTime.expectcfmworkday+' 卖出金额确认'}}</div>
          </li>
        </ul>
        <hr class="xDetail-hr">
        <ul class="xDetail-ul">
          <li class="xDetail-ul-li"><span>{{this.successMessage.fundname}}</span><span>{{this.successMessage.applicationvol+'份'}}</span></li>
        </ul>
        <hr class="xDetail-hr">
        <ul class="xDetail-ul">
          <li class="xDetail-ul-li"><span>订单编号</span><span>{{this.successMessage.appsheetserialno}}</span></li>
        </ul>
        <div class="xDetail-footer">
          <el-button type="normal" @click="reback">确定</el-button>
        </div>
      </section>
      <!-- 充值失败 -->
      <section class="xDetail" v-show="stepDisplay == '3'">
        <div class="xDetail-icon">
          <img src="../../../assets/images/hbb/error_20210309.png" width="40" alt="">
        </div>
        <p class="xDetail-title rColor">卖出失败</p>
        <hr class="xDetail-hr">
        <ul class="xDetail-ul">
          <li class="xDetail-ul-li"><span>失败原因：</span><span>{{wrongReason}}</span></li>
        </ul>
        <hr class="xDetail-hr">
        <div class="xDetail-footer margin-b30">
          <el-button type="normal" @click="reback">确定</el-button>
        </div>
      </section>
    </div>
    <!-- 完善信息 -->
    <Perfect></Perfect>
    <!-- 风险测评 -->
    <RiskTips @func="getFunc"></RiskTips>
  </div>
</template>

<script>
export default {
  data () {
    const isNum = (rule, value, callback) => {
      const ret = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
      if (value < this.min - 0) {
        callback(new Error('本基金最低赎回份额是' + this.min + '份，请重新填写！或联系客服400-818-8000进行操作'))
      } else if (value > this.max - 0) {
        callback(new Error('赎回份额超过最大可用份额，请重新输入'))
      } else if (!ret.test(value)) {
        callback(new Error('赎回份额小数点位数不应超过2位，请重新填写！'))
      } else {
        callback()
      }
    }
    return {
      stepDisplay: '1',
      scopeShow: true,
      sellForm: {
        money: '',
        pay: 0,
        pass: '',
        card: '',
      },
      sellFormRules: {
        money: [
          { required: true, message: '请输入赎回份额', trigger: 'blur' },
          { validator: isNum, trigger: 'blur' }
        ],
        card: [
          { required: true, message: '请选择银行卡', trigger: 'change' },
        ],
        pass: [
          { required: true, message: '请输入密码', trigger: 'blur' },
        ],

      },
      cardShow: false,
      inputType: '',
      fundMessage: '',
      successMessage: '',
      confirmTime: '',
      errorMsg: '',
      sellText: '确认卖出',

      min: '',
      max: '',
      sellRange: '',
      // 入参
      targetsharetype: '',
      channelid: '',
      moneyaccount: '',
      // 错误信息
      wrongReason: '',
    }
  },
  created () {
    this.fundMessage = this.$route.params.fundMessage
    // console.log(this.fundMessage);
    this.sellForm.card = this.$commonJs.getBankInfo(this.fundMessage.channelid) + '(尾号' + this.fundMessage.depositaccount.substr(this.fundMessage.depositaccount.length - 4) + ')'
  },
  mounted () {
    this.getFundListone()
    this.getShareType()
  },
  methods: {
    // 风险测试
    getFunc (val) {
      window.sessionStorage.setItem('riskFlag', val)
    },
    reback () {
      this.$router.push({
        name: 'myAssets'
      })
    },
    //银行卡信息
    // getslectedValue (val,) {
    //   this.sellForm.card = val
    //   this.channelid = val.split('-')[1]
    //   this.moneyaccount = val.split('-')[0]
    // },
    //选中值
    slectedValue (val) {
      window.sessionStorage.setItem('card', val)
      this.sellForm.card = val
      this.channelid = val.split('-')[1]
      this.moneyaccount = val.split('-')[0]
    },
    // 全部卖出
    CashAll () {
      this.sellForm.money = this.fundMessage.availbal
      this.moneyBlur()
    },
    // 获取单只基金信息
    getFundListone () {
      this.$http.post(this.$apiPath.fundListone, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        fundcode: this.fundMessage.fundcode
      }).then(res => {
        if (res.status !== 200 && res.data.code !== '200') return
        const result = res.data.data
        // console.log(res);
        if (result.length > 0) {
          this.min = result[0].per_min_24
          this.max = result[0].per_max_24
          if (Number(this.fundMessage.availbal) < Number(this.min)) {//基金份额小于最小份额
            if (Number(this.fundMessage.fundvol) < Number(this.min)) {
              this.min = this.min
              this.max = this.fundMessage.fundvol
              this.sellRange = '本基金最低赎回范围为' + this.min + '份'
            } else {
              this.min = result[0].per_min_24
              this.max = this.fundMessage.fundvol
              this.sellRange = '本基金赎回范围（' + this.min + '份~' + this.max + '份）'
            }
          } else if (Number(this.fundMessage.availbal) > Number(this.max)) {//基金份额超过最大份额
            this.min = result[0].per_min_24
            this.max = result[0].per_max_24
            this.sellRange = '本基金赎回范围（' + this.min + '份~' + this.max + '份）'
          } else {
            this.min = result[0].per_min_24
            this.max = Number(this.fundMessage.availbal).toFixed(2);
            this.sellRange = '本基金赎回范围（' + this.min + '份~' + this.max + '份）'
          }

        }


      })
    },
    sellClick () {
      this.moneyBlur()
      this.$refs.sellFormRef.validate(valid => {
        if (!valid) return
        this.sellText = '确认中...'
        if (this.sellForm.pay == 0) {//恒宝宝
          this.hbbSell()
        } else {
          this.cardSell()
        }
      })
    },
    // 基金收费方式
    getShareType () {
      this.$http.post(this.$apiPath.shareType, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        fundcode: this.fundMessage.fundcode,
      }).then(res => {
        if (res.status !== 200 && res.data.code !== '200') return
        this.targetsharetype = res.data.data.sharetype
        // console.log(res);
      }).catch(err => { })
    },
    // 卖出到恒宝宝
    hbbSell () {
      this.$http.post(this.$apiPath.sellChangeBuynew, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        passwd: this.$des.enString(this.sellForm.pass, this.$store.state.DESKEY.key1, this.$store.state.DESKEY.key2, this.$store.state.DESKEY.key3),
        fundcode: this.fundMessage.fundcode,//赎回基金
        fundtype: this.fundMessage.fundtype,
        tano: this.fundMessage.tano,//卖出
        vastredeemflag: '0',
        targetsharetype: this.targetsharetype,//
        applicationamount: this.sellForm.money,
        sharetype: 'A',
        channelid: this.fundMessage.channelid,
        // moneyaccount: this.moneyaccount,
        targetfundcode: '162206',//申购基金
        transactionaccountid: this.fundMessage.transactionaccountid,//
        appnew: 1,//新个人中心标志
        deviceId: '',
        fundstatus: '',
      }).then(res => {
        // console.log(res);
        if (res.status !== 200) return
        if (res.data.code == "10000005") {
          // 密码输入错误
          this.errorMsg = res.data.message
          this.sellText = '确认卖出'
        } else if (res.data.code == "9999") {
          // 操作频繁
          this.errorMsg = res.data.message
          this.sellText = '确认卖出'
        } else if (res.data.code == "2004") {
          // 假期暂停
          this.$message.success(res.data.message)
          // this.errorMsg = res.data.message
          this.sellText = '确认卖出'
        } else if (res.data.code == "200") {
          this.comappsheetno = res.data.data.appsheetserialno
          this.stepDisplay = '2'
          this.getqeryPublicTradesByNo(res.data.data.appsheetserialno)
          this.getTime(res.data.data.appsheetserialno)
          // 推送消息
          this.$store.dispatch({
            type: "pushNews",
            index: 7,
            fundname: this.fundMessage.fundcodename,
            money: this.sellForm.money,
            dtDate: "",
            fundname2: ""
          })
        } else {
          this.stepDisplay = '3'
          this.wrongReason = res.data.data.msg ? res.data.data.msg : res.data.message
        }
      }).catch(err => { })
    },
    // 卖出到银行卡
    cardSell () {
      this.$http.post(this.$apiPath.sellFundnew, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        tano: this.fundMessage.tano,//
        fundcode: this.fundMessage.fundcode,//
        fundtype: this.fundMessage.fundtype,
        passwd: this.$des.enString(this.sellForm.pass, this.$store.state.DESKEY.key1, this.$store.state.DESKEY.key2, this.$store.state.DESKEY.key3),
        applicationamount: this.sellForm.money,
        transactionaccountid: this.fundMessage.transactionaccountid,//
        deviceId: '',
        appnew: 1
      }).then(res => {
        if (res.status !== 200) return
        // console.log(res);
        if (res.data.code == "10000005") {
          // 密码输入错误
          this.errorMsg = res.data.message
          this.sellText = '确认卖出'
        } else if (res.data.code == "9999") {
          // 操作频繁
          this.errorMsg = res.data.message
          this.sellText = '确认卖出'
        } else if (res.data.code == "2004") {
          // 假期暂停
          this.$message.success(res.data.message)
          // this.errorMsg = res.data.message
          this.sellText = '确认卖出'
        } else if (res.data.code == "200") {
          const result = res.data.data
          if (result) {
            // console.log(result);
            this.sellText = '确认卖出'
            this.stepDisplay = '2'
            this.getqeryPublicTradesByNo(result.appsheetserialno)
            this.getTime(res.data.data.appsheetserialno)
            // 推送消息
            this.$store.dispatch({
              type: "pushNews",
              index: 3,
              fundname: this.fundMessage.fundcodename,
              money: this.sellForm.money,
              dtDate: "",
              fundname2: ""
            })
          }
        } else {
          this.stepDisplay = '3'
          this.wrongReason = res.data.data.msg ? res.data.data.msg : res.data.message
          this.sellText = '确认卖出'
        }
      }).catch(err => { })
    },
    // 卖出结果
    getqeryPublicTradesByNo (appsheetserialno) {
      this.$http.post(this.$apiPath.qeryPublicTradesByNo, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        appsheetserialno: appsheetserialno,
      }).then(res => {
        if (res.status !== 200 && res.data.code !== '200') return
        if (res.data.data.publicRecord.length > 0) {
          // console.log(res);
          this.successMessage = res.data.data.publicRecord[0]
        }

      }).catch(error => { })
    },
    // 确认中时间
    getTime (appsheetserialno) {
      this.$http.post(this.$apiPath.hbbMessageInfo, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        appsheetserialno: appsheetserialno
      }).then(res => {
        if (res.status !== 200 && res.data.code !== '200') return
        this.confirmTime = res.data.data.hbbTradeInfo[0]
        // console.log(this.confirmTime);
      }).catch(err => { })
    },
    moneyBlur () {
      this.$refs.sellFormRef.validateField('money', (err) => {
        this.scopeShow = err != '' ? false : true
      })
    }


  }
}
</script>

<style lang="less" scoped>
</style>